import { always } from 'ramda';
import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';

import {
  BILLING_PLAN_SELECTED,
  BILLING_PLAN_RESET,
} from 'app/features/billing/actionTypes';
import { pickPayload } from 'app/reducers/helpers';

const selectedPlan = handleActions(
  {
    [BILLING_PLAN_SELECTED]: pickPayload,
    [BILLING_PLAN_RESET]: always(null),
  },
  null,
);

const billing = combineReducers({ selectedPlan });

export default billing;
